export default "__VITE_ASSET__3PgqUCor__"